import { IDataOptions } from '@shared/core/common'
import { GetProfileResponseDto } from '@shared/core/users'
import { useQuery, UseQueryOptions } from 'react-query'
import { useHandleRetry } from 'src/modules/core/hooks/use-handle-retry'
import { ApiService } from 'src/services/api.service'

export const GET_PROFILE_CACHE_KEY = 'get-profile'
export const DEFAULT_GET_PROFILE_CACHE_KEY = [GET_PROFILE_CACHE_KEY, {}]

export function useProfile(params: IDataOptions = {}, options?: UseQueryOptions<GetProfileResponseDto>) {
  const handleRetry = useHandleRetry()

  return useQuery([GET_PROFILE_CACHE_KEY, params], () => ApiService.Profile.getProfile(params), {
    staleTime: 300000,
    retry: handleRetry,
    ...options,
  })
}
